import { render, staticRenderFns } from "./RulePath.vue?vue&type=template&id=050238d0&scoped=true&"
import script from "./RulePath.vue?vue&type=script&lang=js&"
export * from "./RulePath.vue?vue&type=script&lang=js&"
import style0 from "./RulePath.vue?vue&type=style&index=0&id=050238d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050238d0",
  null
  
)

export default component.exports